import React from 'react'
import { convertDate, readingTime } from 'utils'
import { COMMON } from 'utils/intl/common.js'
import LinkAnimate from 'utils/hooks/linkAnimate'
import { cropString } from 'utils'
import { iconArrowDown } from 'utils/icons'

function CardArticle(props) {
  const { slug, data } = props

  return (
    <LinkAnimate className="card-article" to={`blog/${slug}`}>
      <div className="card-article__image">
        <img loading="lazy" src={data.cover.url} alt={`${data.title.text} - Qovery`} />
      </div>
      <div className="card-article__content">
        <span className="f ft-secondary c-text-black-lighter mt-2 mb-1">
          {convertDate(data.date)} · {readingTime(data.content.text)} {COMMON.MIN_READ}{' '}
        </span>
        <h3 className="h2 c-text-black-lighter mb-2">{data.title.text}</h3>
        <p className="c-text-black-lighter mb-1">{cropString(data.description.text, 110)}</p>
        <div className="ft-secondary f f-align-items-center c-text-black-lighter ft-600">
          {COMMON.READ}
          <span className="ml-1">{iconArrowDown}</span>
        </div>
      </div>
    </LinkAnimate>
  )
}

export default CardArticle
